module.exports = __webpack_public_path__ + "static/media/arrow-left.b7aba06b.svg";